import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';

import ActionDropdown from '@/components/basicComponents/actionDropdown';
import { Tooltip } from '@/components/basicComponents/tooltip';
import { Loader } from '@/components/loaders/loader';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { IAiSuggestionsTableData } from '../types';
import { aiSuggestionsTableColumns, getAiSuggestionsTableCellValue } from './table';

interface AiSuggestionsMobileTableProps {
  tableData: IAiSuggestionsTableData[];
  loading: boolean;
  updatingRowId: string | null;
  openEditFieldPage: ({ recordId, fieldType, fieldId }: { recordId: string; fieldType: string; fieldId: string }) => void;
}

const AiSuggestionsMobileTable = ({ tableData, loading, updatingRowId, openEditFieldPage }: AiSuggestionsMobileTableProps) => {
  if (loading) return <Loader />;

  if (!tableData.length) return <NoResults />;

  return (
    <MobileTableWrapper>
      {tableData.map((el) => (
        <Tooltip key={el.recordId} title="This row is disabled because it has no previous AI run." disableTooltip={el.isPreviousAiRunExists}>
          <CustomMobileTableRowWrap loading={updatingRowId === el.recordId ? 1 : 0} disabled={!el.isPreviousAiRunExists}>
            <MobileRow>
              <MobileRowTitle>{aiSuggestionsTableColumns[0].title}</MobileRowTitle>
              <MobileRowValue>{el.strategy}</MobileRowValue>
            </MobileRow>

            <MobileRow>
              <MobileRowTitle>{aiSuggestionsTableColumns[1].title}</MobileRowTitle>
              <MobileRowValue>{getAiSuggestionsTableCellValue(el, 'aiSuggestion')}</MobileRowValue>
            </MobileRow>

            <MobileRow>
              <MobileRowTitle>{aiSuggestionsTableColumns[2].title}</MobileRowTitle>
              <MobileRowValue>{getAiSuggestionsTableCellValue(el, 'answer')}</MobileRowValue>
            </MobileRow>

            {el.isPreviousAiRunExists && updatingRowId !== el.recordId && (
              <ActionDropdownWrapper>
                <ActionDropdown
                  actionDropdownListPosition="center"
                  options={[
                    {
                      name: 'Edit',
                      onClick: () => openEditFieldPage({ recordId: el.recordId, fieldType: el.fieldType, fieldId: el.fieldId })
                    }
                  ]}
                />
              </ActionDropdownWrapper>
            )}
          </CustomMobileTableRowWrap>
        </Tooltip>
      ))}
    </MobileTableWrapper>
  );
};

export default AiSuggestionsMobileTable;

const CustomMobileTableRowWrap = styled(MobileTableRowWrap)<{ disabled: boolean }>`
  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
  background-color: ${({ disabled }) => (disabled ? themeVar('action.disabled') : themeVar('layer.1'))};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

const ActionDropdownWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
